export class CreateGroupParams {
  title: string

  constructor({ title }: { title: string }) {
    this.title = title
  }
}
